export enum TimeFormatEnum {
  '12h' = '12h',
  '24h' = '24h',
}
